/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQConfigOutput } from './mCQConfigOutput';

export type TaskMcqConfig = MCQConfigOutput | null;
